import React from 'react';
import WName, {WArticle} from '../WName';
//import Eon, {EonArticle} from '../Eon';
import QL from './QuestionLink';
import PL from '../problems/ProblemLink';
import AL from '../angles/AngleLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, Qual} from '../common';


// What is Pratty (Africa)?
export const pratty = {
  name: "pratty",
  alternatives: "pratty africa",
  parentName: "प्रतीत्य (Pratty)",
  question: <span>
    What is Pratty Africa?
  </span>,
  answerPreview: <div className="answer-preview">
    <p>It’s a not-nation-state that has stopped playing on the <NW>BOLT</NW> by the rules of <AL>Hell</AL>.</p>
    <p>The name (cf. <PL name="shem">שם</PL>) is from प्रतीत्यसमुत्पाद (pratītyasamutpāda), a Sanskrit word they often translate as ‘interdependent arising’. किमपि न किमपि उत्पद्यते। (Kimapi na kimapi utpadyate: nothing arises from nothing, <QL>apologies</QL> if the <QL name="languages">Sanskrit</QL> is wrong).</p>
[under construction]
  </div>,
  sublist: [
  // What is 'Atomland'?
  {
    name: "atomland",
    alternatives: "atomlander,atomlanders",
    question: "What’s ‘Atomland’?",
    answerPreview: <div className="answer-preview">
      <p>It’s Pratty Africa’s name (cf. <PL name="shem">שם</PL>) for the part of <LRL name="gaia">Planet Earth</LRL> that still sees the <PL>individual</PL> (not the <AL>system</AL>) as primatry. In fierce <PL>denial</PL> and stabbing <PL>ourself</PL> in the leg a million times over, just because we can’t <LRL name="game">agree</LRL> on <PL>metaphysics</PL>.</p>
      <p>No, ‘Atomland’ does not <i>exclude</i> Pratty. Pratty is everything, and that’s the <NW>FOE</NW> (YOUR<sup>™</sup> problem, buster). ‘Atomland’ is a subset <QL name="languages.fingir">fingiendo que sea separado</QL> (pretending it’s <AL name="die alone">apart</AL>), cf. how Georg Cantor built the <LRL name="nepantla">set of all twos in binary</LRL>.</p>
      <p>[under construction]</p>
    </div>
  },

  ],
};

